import React from 'react';
import PropTypes from 'prop-types';

class SearchField extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      searchText: '',
      showReset: false,
    };
  }

  commenceSearch = value => this.props.handleSearch(value);

  handleSearchChange = e => {
    const searchText = e.target.value;

    this.setState({
      searchText,
      showReset: searchText.length > 0,
    });
  };

  handleSearchKeyUp = e => {
    if (e.keyCode !== 13) return;

    this.commenceSearch(this.state.searchText.trim());
  };

  handleSearchClick = e => {
    e.preventDefault();

    this.commenceSearch(this.state.searchText.trim());
  };

  handleSearchReset = e => {
    e.preventDefault();

    this.setState({
      searchText: '',
      showReset: false,
    });

    this.commenceSearch('');
  };

  render() {
    const {placeholder} = this.props;
    const {showReset, searchText} = this.state;

    return (
      <span key="search-field" className="input-icon MHD-search-box">
        <input
          className="form-control input-search page-custom-search-box-input"
          onChange={this.handleSearchChange}
          onKeyUp={this.handleSearchKeyUp}
          placeholder={placeholder}
          type="text"
          value={searchText}
        />

        <a
          className="btn-search page-custom-search-box-btn-search"
          href="#"
          onClick={this.handleSearchClick}
        >
          <i className="fa fa-search" />
        </a>

        {showReset ? (
          <a
            className="btn-reset page-custom-search-box-btn-reset"
            href="#"
            onClick={this.handleSearchReset}
            style={{display: 'inline-block'}}
          >
            <i className="fa fa-times" />
          </a>
        ) : (
          ''
        )}
      </span>
    );
  }
}

SearchField.defaultProps = {
  placeholder: 'Search',
};

SearchField.propTypes = {
  placeholder: PropTypes.string,

  // functions
  handleSearch: PropTypes.func.isRequired,
};

export default SearchField;



// WEBPACK FOOTER //
// ./src/components/Common/Form/SearchField.js